document.addEventListener('DOMContentLoaded', function() {
    const blockMap = document.querySelector('.block-map');
    if (!blockMap) return;

    const svgContainer = blockMap.querySelector('.svg-container');
    const linksContainer = blockMap.querySelector('.location-links');

    if (!svgContainer || !linksContainer) return;

    const links = linksContainer.querySelectorAll('.short-link');
    const mapItems = svgContainer.querySelectorAll('[id]');

    // Koppla länkar till kart-id
    links.forEach(link => {
        link.dataset.mapId = link.dataset.mapId || link.id || '';
    });

    // 1. Hover på länkar -> markera bara kartan (active)
    links.forEach(link => {
        const id = link.dataset.mapId;

        link.addEventListener('mouseenter', () => {
            mapItems.forEach(m => {
                m.classList.toggle('active', m.id === id);
            });
        });

        link.addEventListener('mouseleave', () => {
            mapItems.forEach(m => m.classList.remove('active'));
        });
    });

    // 2. Hover på kartan -> markera motsvarande länk (open)
    mapItems.forEach(item => {
        const id = item.id;

        item.addEventListener('mouseenter', () => {
            links.forEach(l => {
                l.classList.toggle('open', l.dataset.mapId === id);
            });
        });

        item.addEventListener('mouseleave', () => {
            links.forEach(l => l.classList.remove('open'));
        });
    });
});
//# sourceMappingURL=location.js.map
